export class BodyPartModel {
    bodypartno: number
    body_part: string

    constructor(
        bodypartno: number,
        body_part: string
    ) {
        this.bodypartno = bodypartno
        this.body_part = body_part
    }
}